import { forkJoin, map, Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  ENVIRONMENT,
  EnvironmentModel,
} from '@lyceo/lyceo-pupil-app/shared/util-environment';

import { Injectable, inject } from '@angular/core';
import {
  BookSessionDto,
  ParagraphSessionDto,
} from '@lyceo/lyceo-pupil-app/practise/util-models';
import {
  ExaminationSessionDetailedDto,
  ExaminationSessionDto,
} from './+state/examination-session/examination-session.model';
@Injectable({
  providedIn: 'root',
})
export class ExaminationSessionService {
  private readonly environment: EnvironmentModel =
    inject<EnvironmentModel>(ENVIRONMENT);
  private readonly http: HttpClient = inject(HttpClient);

  public getExaminationSessionDetailed(
    sessionId: string,
    questionnaireId: string,
  ): Observable<ExaminationSessionDetailedDto> {
    const url: string = `${this.environment.alfredApiUrl}/api/sessions/${sessionId}`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http
      .get<ExaminationSessionDetailedDto>(url, { headers: headersToSend })
      .pipe(map((session) => ({ ...session, questionnaireId })));
  }

  public getExaminationSessions(
    userId: string,
    questionnaireId: string,
  ): Observable<ExaminationSessionDto[]> {
    const url: string = `${this.environment.alfredApiUrl}/api/users/${userId}/examination-sessions?examinationQuestionnaire.id=${questionnaireId}&itemsPerPage=3&order%5BfinishedAt%5D=desc&exists%5BfinishedAt%5D=true`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http
      .get<ExaminationSessionDto[]>(url, { headers: headersToSend })
      .pipe(
        map((sessions) =>
          sessions.map((session) => ({ ...session, questionnaireId })),
        ),
      );
  }

  public getExaminationSessionsByIds(
    userId: string,
    questionnaireIds: string[],
  ): Observable<ExaminationSessionDto[]> {
    if (!questionnaireIds.length) {
      return of([]);
    }
    return forkJoin(
      questionnaireIds.map((id) => this.getExaminationSessions(userId, id)),
    ).pipe(map((x) => x.reduce((arr, curr) => [...arr, ...curr])));
  }

  public getParagraphSession(
    paragraphId: string,
    questionnaireId: string,
  ): Observable<ParagraphSessionDto> {
    const url: string = `${this.environment.practiceApiUrl}/api/paragraphs/${paragraphId}/sessions/${questionnaireId}`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<ParagraphSessionDto>(url, { headers: headersToSend });
  }

  public getBookSession(
    bookId: string,
    questionnaireId: string,
  ): Observable<BookSessionDto> {
    const url: string = `${this.environment.practiceApiUrl}/api/books/${bookId}/sessions/${questionnaireId}`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<BookSessionDto>(url, { headers: headersToSend });
  }
}
